import LearningMedia from './LearningMedia.vue';
import LearningMediaList from './LearningMediaList.vue';
export default {
  LearningMedia,
  LearningMediaList,
};
